// frontend/src/components/common/WalletWidget.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './WalletWidget.css';

const WalletWidget = ({ points = 0 }) => {
  const navigate = useNavigate();
  const euroValue = (points / 10).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <motion.div
      className="ww-root"
      onClick={() => navigate('/dashboard/partner/purchase-packs')}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      title="Recharger mon wallet"
    >
      {/* Icône */}
      <div className="ww-icon">
        <i className="fas fa-coins"></i>
      </div>

      {/* Texte */}
      <div className="ww-body">
        <span className="ww-label">Solde</span>
        <div className="ww-balance">
          <span className="ww-value">{points.toLocaleString('fr-FR')}</span>
          <span className="ww-unit">pts</span>
          <span className="ww-dot" />
        </div>
      </div>

      {/* Tooltip au survol */}
      <div className="ww-tooltip">
        ≈ {euroValue} TND
        <div className="ww-tooltip-arrow" />
      </div>
    </motion.div>
  );
};

export default WalletWidget;
